import React from 'react';
import cx from 'classnames';

export function dropHandlersMixin(supportedTypes, effect, onDrop, strictMatch) {

  Object.assign(this.state, {droppable: false});

  let dragEnters = 0;
  let matchingType = null;

  function getMatchingType(dataTransfer) {
    for (let t = 0; t < dataTransfer.types.length; t++) {
      for (let i = 0; i < supportedTypes.length; i++) {
        const type = dataTransfer.types[t];
        const supportedType = supportedTypes[i];
        if ((strictMatch && type === supportedType) || (!strictMatch && type.indexOf(supportedType) === 0)) {
          return type;
        }
      }
    }
    return null;
  }

  function isNorth(e) {
    const {top, height} = e.currentTarget.getBoundingClientRect();
    return e.clientY < top + height * 0.5;
  }

  return {
    onDragOver: e => {
      if (matchingType !== null) {
        e.preventDefault();
        e.dataTransfer.dropEffect = effect;
        const north = isNorth(e);
        this.setState({droppable: true, north})
      }
    },

    onDragEnter: e => {
      if (dragEnters < 1) {
        matchingType = getMatchingType(e.dataTransfer);
        if (matchingType !== null) {
          dragEnters = 1;
          const north = isNorth(e);
          this.setState({droppable: true, north})
        }
      } else {
        dragEnters++;
      }
    },

    onDragLeave: () => {
      if (dragEnters > 0) {
        dragEnters--;
        if (dragEnters === 0) {
          matchingType = null;
          this.setState({droppable: false});
        }
      }
    },

    onDrop: e => {
      if (dragEnters > 0) {
        dragEnters = 0;
        this.setState({droppable: false});
        if (!e.defaultPrevented) {
          onDrop(e.dataTransfer.getData(matchingType), matchingType, this.state.north);
          e.preventDefault();
        }
      }
    },
  };
}

export default class Droppable extends React.PureComponent {

  constructor({supportedTypes, effect, onDrop, strictMatch}) {
    super();
    this.state = {};
    this.dropHandlers = dropHandlersMixin.call(this, supportedTypes, effect, onDrop, strictMatch);
  }

  render() {
    const {children, supportedTypes, effect, strictMatch, onDrop, className, tag, ...props} = this.props;
    let verticalPos = this.state.droppable ? (this.state.north ?  'north': 'south') : null;
    const Tag = tag || 'div';
    return <Tag {...this.dropHandlers} {...props} className={cx(className, {droppable: this.state.droppable}, verticalPos)}>
      {children}
    </Tag>
  }
}
